
import React, { useEffect } from "react";
import Advertisement from "./Advertisement";
import Events from "./Events";
import ActiveUsers from "./ActiveUsers";
import NewDishes from "./NewDishes";
import PopularDishes from "./PopularDishes";
import Statistics from "./Statistics";
import { useDispatch } from "react-redux"; 
import { Dispatch } from "@reduxjs/toolkit";
import { setNewDishes, setPopularDishes, setTopUsers } from "./slice";
import { Product } from "../../../lib/types/product";
import ProductService from "../../services/ProductService";
import MemberService from "../../services/MemberService";
import { Member } from "../../../lib/types/member";
import "../../../css/home.css";

/** REDUX SLICE & SELECTOR */
 const actionDispatch = (dispatch: Dispatch) => ({
  setPopularDishes: (data: Product[]) => dispatch(setPopularDishes(data)),
  setNewDishes: (data: Product[]) => dispatch(setNewDishes(data)),
  setTopUsers: (data: Member[]) => dispatch(setTopUsers(data)),
 });
 

export default function HomePage() {
  const { setPopularDishes, setNewDishes, setTopUsers } = actionDispatch(useDispatch());
// Selector: Store => Data  


useEffect(() => {
  const product = new ProductService();
  product
   .getProducts({
    page: 1,
    limit: 8,
    order: "productViews", // backend sorts by views descending
  })
  .then((data) => setPopularDishes(data))
   .catch((err) => console.log(err));

   product
   .getProducts({
    page: 1,
    limit: 4,
    order: "createdAt",
  })
  .then((data) => {
    setNewDishes(data);
  })
   .catch((err) => console.log(err));

   const member = new MemberService();
   member
   .getTopUsers()
   .then(data => {
    setTopUsers(data);
   })
   .catch(err => console.log(err));

}, [setPopularDishes, setNewDishes, setTopUsers]);

  return <div className={"homepage"}>
   <Statistics/>
   <PopularDishes/>
   <NewDishes/>
   <Advertisement/>
   <ActiveUsers/>
   <Events/>

  </div>;

}





